import React from "react";
import styled from "styled-components";
import { CSS_BREAKPOINTS_MIN, PAPER_WHITE_COLOR } from "../config/constants";

const TextTitle = styled.h1`
  font-size: ${(props) => props.fontsize ?? "15px"};
  line-height: ${(props) => props.lineHeight ?? "1.25"};
  margin-top: ${(props) => props.marginTop ?? "5px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0"};
  margin-left: ${(props) => props.marginLeft ?? "0"};
  margin-right: ${(props) => props.marginRight ?? "0"};
  text-align: ${(props) => props.textAlign ?? "left"};
  color: ${(props) => props.color ?? "white"};
  font-weight: ${(props) => props.fontWeight ?? "500"};
  font-family: ${(props) => props.fontFamily ?? "Poppins"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  letter-spacing: ${(props) => props.letterSpacing ?? "0.075px"};
  text-transform: ${(props) => props.textTransform ?? "none"};
  overflow: hidden;

  @media ${CSS_BREAKPOINTS_MIN.sm} {
    font-size: ${(props) => props.desktopFontSize ?? props.fontsize};
    margin-left: ${(props) => props.desktopMarginLeft ?? "0"};
    letter-spacing: ${(props) => props.letterSpacingDesktop ?? "0.075px"};
    line-height: ${(props) => props.lineHeightDesktop ?? "1.25"};
    font-weight: ${(props) => props.fontWeightDesktop ?? "500"};
  }

  span {
    font-weight: 500;
    color: ${(props) => props.spanColor ?? PAPER_WHITE_COLOR};
    font-size: 11px;
  }
`;

const Title = (props) => {
  return <TextTitle {...props}>{props.children}</TextTitle>;
};

export default Title;
